module.exports = __webpack_public_path__ + "static/media/bin.4c86b712.svg";